import React from 'react';
import { Box, Pagination, Typography } from '@mui/material';

interface AgentPaginationProps {
  totalPageCount: number;
  page: number;
  onPageChange: (newPage: number) => void;
  agentsCardsPerPage: number;
  filteredAgentsLength: number;
  isMobile: boolean;
}

const AgentPagination: React.FC<AgentPaginationProps> = ({
  totalPageCount,
  page,
  onPageChange,
  agentsCardsPerPage,
  filteredAgentsLength,
  isMobile,
}) => {
  if (filteredAgentsLength === 0) return null;
  return (
    <Box sx={{ mt: 4, mb: 4, display: 'flex', justifyContent: 'center', width: '100%' }}>
      <Pagination
        count={totalPageCount}
        page={page}
        onChange={(event, value) => onPageChange(value)}
        color="primary"
        size={isMobile ? 'small' : 'medium'}
        showFirstButton
        showLastButton
      />
      <Typography variant="caption" sx={{ mt: 1 }} fontSize={'0.75rem'}>
        Showing {(page - 1) * agentsCardsPerPage + 1}-
        {Math.min(page * agentsCardsPerPage, filteredAgentsLength)} of {filteredAgentsLength}
      </Typography>
    </Box>
  );
};
export default AgentPagination;
